var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart_container ml-0"},[_c('Doughnut',{attrs:{"chart-data":_vm.chartData,"chart-options":_vm.chartOptions,"plugins":_vm.plugins}}),_c('div',{staticClass:"col text-center h5 mt-0"},[_vm._v(" "+_vm._s(_vm.$t('Deficit' + _vm.budgetType))+_vm._s(_vm._f("formatMoney")(_vm.unfunded))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }